import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    localidades: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    provincia: null,

    provinciaId: 0,
    localidadesProvincia: [],
    localidadesProvinciaList: [],

    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_LOCALIDADES'(state) {
        state.localidades = [];
    },
    'LOCALIDADES'(state, localidades) {
        state.localidades = localidades;
    },
    'LOCALIDADES_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LOCALIDADES_PROVINCIA'(state, provinciaId) {
        state.provinciaId = provinciaId;
        state.localidadesProvincia = [];
        state.localidadesProvinciaList = [];
    },
    'LOCALIDADES_PROVINCIA'(state, localidadesProvincia) {
        state.localidadesProvincia = localidadesProvincia;
    },
    'LOCALIDADES_PROVINCIA_LIST'(state, localidadesProvinciaList) {
        state.localidadesProvinciaList = localidadesProvinciaList;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, localidades) {
        state.list = localidades;
        state.selectList = localidades.map(localidad => localidad.nombre.trim());
    },
};

const actions = {
    getLocalidades: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LOCALIDADES');

            var queryString = ''
            if ( state.paginaActual != 0) {
              queryString = '?'
                + 'pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            if (state.nombre != '') {
                if (queryString == '') {
                    queryString += '?nombre=' + state.nombre;
                } else {
                    queryString += '&nombre=' + state.nombre;
                }
            }
            if (state.provincia) {
                if (state.provincia.id != 0) {
                    queryString += '&provinciaId=' + state.provincia.id;
                }
            }
      
            apiAxios.get('localidades' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('LOCALIDADES_PAGINATION', params);
                    }
                    commit('LOCALIDADES', res.data)
                    
                    resolve();
                })
                .catch(error => {
                    resolve();
                })
            }, error => {
                reject(error);
            })                
    },
    getLocalidadesProvincia: ({commit}, provinciaId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LOCALIDADES_PROVINCIA', provinciaId);

            apiAxios.get('localidades/provincia/' + provinciaId + '/list')
                .then(res => {
                    var list = [];
                    for(let key in res.data) {
                        const localidad = res.data[key];
                        list.push(localidad.nombre.trim());
                    }             
                    commit('LOCALIDADES_PROVINCIA', res.data);
                    commit('LOCALIDADES_PROVINCIA_LIST', list);

                    resolve();
                })
                .catch(error => {
                    resolve();
                })
            }, error => {
                reject(error);
            })
    },
    getList: ({ commit }, provinciaId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let query = '';
            if (provinciaId) {
                if (provinciaId != 0) {
                    query= '?provinciaId=' + provinciaId;
                }
            }

            apiAxios.get('localidades/list' + query)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

const getters = {
    getField,

    provinciaId (state) {
        return state.provinciaId;
    },
    localidadesProvincia (state) {
        return state.localidadesProvincia;
    },
    localidadesProvinciaList (state) {
        return state.localidadesProvinciaList;
    },
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}